<doc>地图组件</doc>
<template>
  <div class="map-div"> 
    <!-- 地图渲染DOM -->
    <div id="map-ol"></div>
    
    <!-- 图层选择组件 -->
    <!-- <layerSelect v-if="layerSelectShow" v-model="mapTypeName"></layerSelect> -->
    <inputSearch class = 'seach' @data="drawFinsh" @zb="zbChange" :mapObject="mapObject" @change="typeChange" :type="type"></inputSearch>
    <!-- 鼠标绘制多边形 -->
    <drawCom
      v-if="mapType=='1'&&(type=='1'||type=='2')"
      :mapObject="mapObject"
      :dataList ='dataList'
      @drawFinsh="drawFinsh"
    ></drawCom>
    <!-- 状态栏 -->
    <statusBar
      v-if="mapObject"
      :mapObject="mapObject"
      :mapConfig="mapConfig"
    ></statusBar>
  </div>
</template>
<script>
import MapObject from "./js/map";
// import layerSelect from "./components/layerSelect.vue";
import statusBar from "./components/statusBar.vue";
import drawCom from "./components/drawCom.vue";
import inputSearch from "./components/inputSearch.vue";

export default {
  components: {
    // layerSelect, // 图层选择组件
    statusBar, // 状态栏
    drawCom, // 鼠标绘制多边形
    inputSearch,
  },
  props: [
    'dataList',
    'center',
    'list',
    'showIcon',
    'type'
  ],

  data() {
    return {
      points:null,
      mapObject:null, // 地图引擎加载对象
      mapTypeName: "TSLM", // 地图引擎默认加载底图。可选择值：GDM、TSM、TSLM、Google、OMS（默认）
      layerSelectShow: true, // 是否开启底图选择器。true 显示比例尺；flase 不显示比例尺
      mapConfig: {
        // 地图属性配置
        mouseMove: true, // 开始鼠标移动事件
        mapMoved: true, // 地图移动完成事件
        mouseDraw: true, // 鼠标绘制
      },
      mapType:'1',
      jw:['116.39126','39.90713'],
      zoom:16
    };
  },

  watch: {
    mapTypeName: {
      // 监听底图切换
      handler(newVal, oldVal) {
        this.mapObject.changeMap(this.mapTypeName);
      },
    },
  
  },
  computed: {
    show() {
      return this.showIcon
    }
  },
  mounted() {
    this.$nextTick(() =>{
      if(this.dataList){
        this.jd= JSON.parse(this.dataList)[0][0]
        this.wd= JSON.parse(this.dataList)[0][1]

      }
      if(document.getElementById('map-ol')){
        document.getElementById('map-ol').innerHTML = '';
        this.mapObject = null
      }
      this.initMap(); // 初始化地图引擎
    })
   
  },

  methods: {
    // 初始化地图引擎
    initMap() {
      // 初始化地图引擎。(DOM ID，初始中心点坐标数组, 初始层级, 初始底图, 其他配置对象)
      if(this.center.length>0){
        this.jw = this.center
        this.zoom = 16
      }else{
        this.jw = localStorage.getItem("mapCentre")?localStorage.getItem("mapCentre").split(','):[116.20, 39.56]
        this.zoom = 9
      }
      this.mapObject = new MapObject(
        "map-ol",
        this.jw,
        this.zoom,
        this.mapTypeName,
        {
          scale: true, // 开启比例尺
          ...this.mapConfig,
        },
        this.list,
        this.show
      );
      if(this.list){
        if(this.list.length>0){
          this.mapObject.inverseAnalysis(this.calculateCenter(this.list).lon,this.calculateCenter(this.list).lat)
        }else{
          // this.mapObject.inverseAnalysis(points)
        }
        this.$emit("finesedok", this.list);
      }
      if(this.type=='3'){
        this.mapObject.registClick(3)
      }
      // this.mapObject.addPolygon("wjwDraw",this.list);
    },

    // 完成绘制覆盖物回调
    drawFinsh(points) {
      if(points.length>0){
        this.mapObject.inverseAnalysis(this.calculateCenter(points).lon,this.calculateCenter(points).lat)
      }else{
        // this.mapObject.inverseAnalysis(points)
      }
      this.$emit("finesedok", points);
    },
    //获取中心点
    calculateCenter(lnglatarr){
      var total = lnglatarr.length;
      var X = 0,
        Y = 0,
        Z = 0;
      lnglatarr.forEach(function (lnglat) {
        var lng = (lnglat[0] * Math.PI) / 180;
        var lat = (lnglat[1] * Math.PI) / 180;
        var x, y, z;
        x = Math.cos(lat) * Math.cos(lng);
        y = Math.cos(lat) * Math.sin(lng);
        z = Math.sin(lat);
        X += x;
        Y += y;
        Z += z;
      });
      X = X / total;
      Y = Y / total;
      Z = Z / total;

      var Lng = Math.atan2(Y, X);
      var Hyp = Math.sqrt(X * X + Y * Y);
      var Lat = Math.atan2(Z, Hyp);
      console.log(Lng, Lat, Hyp);
      return {
        lon: ((Lng * 180) / Math.PI).toFixed(5),
        lat: ((Lat * 180) / Math.PI).toFixed(5),
      };
    },
    zbChange(points){
      this.$emit("zb", points);
    },
    typeChange(e){
      if(typeof(e)=='string'){
        this.mapType = e;
      }
      this.$emit("finesedok", {});
      this.$emit("zb", []);
    }
  },
};
</script>
<style scoped>
.map-div,
#map-ol {
  height: 500px;
  width: 1170px;
  background-color: #a4cdff;
  position: relative;
}

div /deep/.ol-attribution,
div /deep/.ol-zoom {
  display: none;
}

.draw-div {
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: 12px;
  padding: 5px 10px;
  background-color: #fff;
  box-shadow: 0 2px 2px rgb(0 0 0 / 15%);
}

.draw-btn {
  width: 100%;
  margin: 5px 0;
  cursor: pointer;
}

</style>
